import { render, staticRenderFns } from "./InstitutionalDialog.vue?vue&type=template&id=7ae4b0ef&"
import script from "./InstitutionalDialog.vue?vue&type=script&lang=js&"
export * from "./InstitutionalDialog.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionalDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports